export default __webpack_public_path__ + "static/media/iosgame.84ee781b.png";